define('post-editor/table-plugin',['post-editor/sidebar-api', 'post-editor/mce-tools'], function(api, mceTools) {
	var tableElement;
	var editor;

	function mapColors() {
		var i, colors = [], colorMap;
		
		var deColorMap = [
			"000000", "Schwarz",
			"993300", "Braun-Orange",
			"333300", "Dunkles Olivgrün",
			"003300", "Dunkles Grün",
			"003366", "Dunkles Himmelsblau",
			"000080", "Marinenblau",
			"333399", "Indigo",
			"333333", "Sehr dunkles Grau",
			"800000", "Kastanie",
			"FF6600", "Orange",
			"808000", "Olivgrün",
			"008000", "Grün",
			"008080", "Krickentengrün",
			"0000FF", "Blau",
			"666699", "Grau-Blau",
			"808080", "Grau",
			"FF0000", "Rot",
			"FF9900", "Gelb-Orange",
			"99CC00", "Gelb-Grün",
			"339966", "Seegrün",
			"33CCCC", "Blasstürkis",
			"3366FF", "Königsblau",
			"800080", "Violett",
			"999999", "Mittleres Grau",
			"FF00FF", "Magenta",
			"FFCC00", "Gold",
			"FFFF00", "Gelb",
			"00FF00", "Limone",
			"00FFFF", "Hellblau",
			"00CCFF", "Himmelsblau",
			"993366", "Braun",
			"FFFFFF", "Weiß",
			"FF99CC", "Pink",
			"FFCC99", "Pfirsich",
			"FFFF99", "Hellgelb",
			"CCFFCC", "Blasses Grün",
			"CCFFFF", "Blasses Cyan",
			"99CCFF", "Blasses Blau",
			"CC99FF", "Pflaume"
		];

		for (i = 0; i < deColorMap.length; i += 2) {
			colors.push({
				text: deColorMap[i + 1],
				color: '#' + deColorMap[i]
			});
		}

		return colors;
	}

	function renderColorPicker() {
		var cols = 8;
		var rows = 5;
		
		var ctrl = this, colors, color, html, last, x, y, i, id = ctrl._id, count = 0;

		function getColorCellHtml(color, title) {
			return (
				'<td class="mce-grid-cell">' +
					'<div id="' + id + '-' + (count++) + '"' +
						' data-mce-color="' + (color ? color : '') + '"' +
						' role="option"' +
						' tabIndex="-1"' +
						' style="background-color: ' + color + ';"' +
						' title="' + editor.translate(title) + '">' +
					'</div>' +
				'</td>'
			);
		}

		colors = mapColors();

		html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
		last = colors.length - 1;

		for (y = 0; y < rows; y++) {
			html += '<tr>';

			for (x = 0; x < cols; x++) {
				i = y * cols + x;

				if (i > last) {
					html += '<td></td>';
				} else {
					color = colors[i];
					html += getColorCellHtml(color.color, color.text);
				}
			}

			html += '</tr>';
		}

		html += '</tbody></table>';

		return html;
	}

	function onPanelClick(e) {
		var buttonCtrl = this.parent(), value;

		value = e.target.getAttribute('data-mce-color');
		if (value) {
			if (this.lastId) {
				document.getElementById(this.lastId).setAttribute('aria-selected', false);
			}

			e.target.setAttribute('aria-selected', true);
			this.lastId = e.target.id;

			buttonCtrl.hidePanel();
			buttonCtrl.color(value);
			var formats = {};
			formats[buttonCtrl.settings.format] = value;
			applyFormat(buttonCtrl.settings.context, formats);
		} else if (value !== null) {
			buttonCtrl.hidePanel();
		}
	}

	function onButtonClick() {
		var self = this;

		if (self._color) {
			var formats = {};
			formats[self.settings.format] = self._color;
			applyFormat(self.settings.context, formats);
		}
	}
	
	function getSelectedCells() {
		var cells = editor.dom.select('td.mce-item-selected,th.mce-item-selected');
		var cellElm = editor.dom.getParent(editor.selection.getStart(), 'td,th');
		if (!cells.length && cellElm) {
			cells.push(cellElm);
		}
		return cells;
	}

	function applyFormat(context, formats) {
		editor.focus();
		editor.undoManager.transact(function() {
			for (var format in formats) {
				if (!formats.hasOwnProperty(format))
					continue;
				var value = formats[format];

				switch (context) {
				case 'table+cells':
					mceTools.setCss($(tableElement).find('td'), format, value);
					mceTools.setCss($(tableElement), format, value);
					break;
				case 'table':
					mceTools.setCss($(tableElement), format, value);
					break;
				case 'selected-cells':
					var cells = getSelectedCells();
					mceTools.setCss($(cells), format, value);
					break;
				}
			}
		});
		editor.nodeChanged();
	}

	function getCurrentColor() {
		var color;

		editor.dom.getParents(editor.selection.getStart(), function(elm) {
			var value;

			if ((value = elm.style[format == 'forecolor' ? 'color' : 'background-color'])) {
				color = value;
			}
		});

		return color;
	}
	
	var borderKinds = {
		full: 'Alle Rahmenlinien',
		inner: 'Nur innere Rahmenlinien',
		none: 'Kein Rahmen',
		outer: 'Nur äußere Rahmenlinien',
		horizontal: 'Nur innere horizontale Rahmenlinien',
		'horizontal-outer': 'Äußere und horizontale Rahmenlinien'
	};
	var defaultborderKind = 'full';
	
	var borderKindToolbar = [];
	var formatDef = {};
	for (var name in borderKinds) {
		if (!borderKinds.hasOwnProperty(name))
			continue;
		var text = borderKinds[name];
		(function(name, text) {
			var formatName = 'border' + name;
			borderKindToolbar.push({
				type: 'button',
				icon: 'border-' + name,
				cssClass: 'border-' + name,
				tooltip: text,
				onPostRender: function() {
					var self = this;
					editor.formatter.formatChanged(formatName, function(state) {
						self.active(state);
					});
					self.active(editor.formatter.match(formatName));
				},
				onclick: function() {
					editor.formatter.apply(formatName);
				}
			});
			
			formatDef[formatName] = [{
				selector: 'table',
				attributes: {class: 'border-' + name},
				onmatch: function(node, format, item_name) {
					if (name == defaultborderKind) {
						// default style is active if none of the other styles is active
						return Object.getOwnPropertyNames(borderKinds)
							.every(function(s) {
								return s == name || !$(node).hasClass('border-' + s);
							});
					}
					return $(node).hasClass('border-' + name);
				}
			}];
		})(name, text);
	}
	
	var borderStyles = [
		{
			value: '1px solid',
			text: 'Dünn'
		},{
			value: '2px solid',
			text: 'Mittel'
		},{
			value: '3px solid',
			text: 'Dick'
		},{
			value: '1px dashed',
			text: 'Gestrichelt'
		},{
			value: '2px dashed',
			text: 'Gestrichelt dick'
		},{
			value: '1px dotted',
			text: 'Gepunktet'
		},{
			value: '2px dotted',
			text: 'Gepunktet dick'
		},{
			value: '3px double',
			text: 'Doppelt'
		},{
			value: '5px double',
			text: 'Doppelt dick'
		}
	];
	
	borderStyles.forEach(function(style) {
		style.textStyle = 'display: block; font-size: 0; color: transparent; margin-top: -8px; margin-bottom: 8px;' +
		'border-bottom: ' + style.value + ' black;';
	});
	
	api.defineGroups('table', [ {
		title: 'Tabelle',
		type: 'toolbar',
		onOpen: function(ui, element, ed) {
			tableElement = element;
		},
		init: function(ed) {
			editor = ed;
			editor.formatter.register(formatDef);
		},
		items: [{
			type: 'buttongroup',
			items: [{
				type: 'button',
				icon: 'insert-row-before',
				cmd: 'mceTableInsertRowBefore',
				tooltip: 'Zeile davor einfügen'
			},{
				type: 'button',
				icon: 'insert-row-after',
				cmd: 'mceTableInsertRowAfter',
				tooltip: 'Zeile danach einfügen'
			},{
				type: 'button',
				icon: 'insert-column-before',
				cmd: 'mceTableInsertColBefore',
				tooltip: 'Spalte davor einfügen'
			},{
				type: 'button',
				icon: 'insert-column-after',
				cmd: 'mceTableInsertColAfter',
				tooltip: 'Spalte danach einfügen'
			},{
				type: 'button',
				icon: 'delete-row',
				cmd: 'mceTableDeleteRow',
				tooltip: 'Zeile löschen'
			},{
				type: 'button',
				icon: 'delete-column',
				cmd: 'mceTableDeleteCol',
				tooltip: 'Spalte löschen'
			}]
		},{
			type: 'buttongroup',
			items: [{
				type: 'button',
				icon: 'delete-table',
				cmd: 'mceTableDelete',
				tooltip: 'Tabelle löschen'
			}]
		},{
			type: 'buttongroup',
			items: [{
				type: 'button',
				icon: 'merge-cells',
				tooltip: 'Zellen verbinden',
				cmd: 'mceTableMergeCells'
			},{
				type: 'button',
				icon: 'split-cells',
				tooltip: 'Zellen teilen',
				cmd: 'mceTableSplitCells'
			}]
		},{
			type: 'form',
			layout: 'grid',
			columns: 1,
			padding: 0,
			items: [{
				type: 'toolbar',
				label: 'Ausrichtung:',
				items: [{
					type: 'listbox',
					fixedWidth: true,
					values: [{
						text: 'Normal',
						value: 'none'
					},{
						text: 'Links',
						value: 'left'
					},{
						text: 'Rechts',
						value: 'right'
					}],
					onselect: function(e) {
						applyFormat('table', { float: e.control.settings.value } );
					},
					onPostRender: function() {
						var self = this;
						editor.on('nodeChange', function(e) {
							var table = $(e.element).closest('table');
							var value = table.css('float') || 'none';
							self.value(value);
						});
					}
				}]
			}]
		}]
	},{
		title: 'Rahmen und Hintergründe',
		type: 'form',
		layout: 'grid',
		columns: 1,
		padding: 0,
		items: [{
			type: 'toolbar',
			items: [{
				type: 'buttongroup',
				items: borderKindToolbar
			}]
		},{
			type: 'toolbar',
			label: 'Rahmenstil:',
			items: [{
				type: 'listbox',
				values: borderStyles,
				fixedWidth: true,
				onPostRender: function() {
					var self = this;
					function applyValue(value) {
						$(self.getEl()).find('button').attr('style', 'height: 28px; font-size: 0;');
						$(self.getEl()).find('button:not(:has(span))').append('<span>');
						$(self.getEl()).find('button span').attr('style',
							'display: block; color: transparent; width: 50px; ' +
							'margin-top: -20px; border-bottom: ' + value + ' black;');
					}
					
					editor.on('nodeChange', function(e) {
						var table = $(e.element).closest('table');
						var value = '1px solid';
						if (table.length && table.css('border-top-style') != 'none') {
							value = table.css('border-top-width') + ' ' + table.css('border-top-style');
						}
						self.value(value);
						applyValue(value);
					});
					applyValue('1px solid');
				},
				onselect: function(e) {
					if (e.control.settings.value) {
						var parts = e.control.settings.value.split(' ');
						applyFormat('table+cells', {
							'border-width': parts[0],
							'border-style': parts[1]
						});
					}
				}
			}]
		},{
			// colorbutton directly in form messes up width
			type: 'toolbar',
			label: 'Rahmenfarbe:',
			items: [{
				type: 'colorbutton',
				icon: 'backcolor',
				format: 'border-color',
				context: 'table+cells',
				panel: {
					role: 'application',
					ariaRemember: true,
					html: renderColorPicker,
					onclick: onPanelClick
				},
				onclick: onButtonClick
			}]
		},{
			type: 'toolbar',
			label: 'Zellhintergrund:',
			items: [{
				type: 'colorbutton',
				icon: 'backcolor',
				format: 'background-color',
				context: 'selected-cells',
				panel: {
					role: 'application',
					ariaRemember: true,
					html: renderColorPicker,
					onclick: onPanelClick
				},
				onclick: onButtonClick
			}]
			
		}]
	},{
		title: 'Kopieren und Einfügen',
		collapsedByDefault: true,
		type: 'panel',
		layout: 'flow',
		items: [{
			type: 'button',
			text: 'Zeile ausschneiden',
			cmd: 'mceTableCutRow'
		},{
			type: 'button',
			text: 'Zeile kopieren',
			cmd: 'mceTableCopyRow'
		},{
			type: 'button',
			text: 'Zeile davor einfügen',
			cmd: 'mceTablePasteRowBefore'
		},{
			type: 'button',
			text: 'Zeile danach einfügen',
			cmd: 'mceTablePasteRowAfter'
		}]
	}]);
});

